import type { IconProps } from './types';
import './icons.css';

export default function Block({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      width={width || 20}
      height={height || 20}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon icon-block ${className || ''}`}
    >
      <path
        fill="currentColor"
        d="M10 1.667c-4.592 0-8.333 3.74-8.333 8.333 0 4.592 3.74 8.333 8.333 8.333s8.333-3.74 8.333-8.333S14.593 1.667 10 1.667Zm0 1.666A6.654 6.654 0 0 1 16.667 10a6.638 6.638 0 0 1-1.402 4.087L5.913 4.735A6.637 6.637 0 0 1 10 3.333Zm-5.265 2.58 9.352 9.352A6.637 6.637 0 0 1 10 16.667 6.654 6.654 0 0 1 3.333 10c0-1.544.526-2.959 1.402-4.087Z"
      />
    </svg>
  );
}
